import * as Sentry from "@sentry/react-native";
// import { ReactNativeTracing } from "@sentry/react-native";
import * as Application from "expo-application";

import { getDeviceIdentifier } from "@/hooks/device";
import { getAppVariant, isMarketingMode } from "@/utils/expo";

export const initializeSentry = (currentExpoRelease: string): void => {
  // Disable Sentry in marketing mode to prevent error reporting during demos
  if (isMarketingMode()) {
    return;
  }

  const appVariant = getAppVariant();

  // const routingInstrumentation = new Sentry.ReactNavigationInstrumentation();

  // Do not use env variables to load the DNS. If that fails, sentry would not get initialized.
  Sentry.init({
    debug: false,
    dsn: "https://a419a447eb22f38f047ba1e82fac83dd@o4506895076229120.ingest.us.sentry.io/4506900449001472",
    environment: appVariant,
    // integrations: [
    //   new ReactNativeTracing({
    //     routingInstrumentation,
    //     // ...
    //   }),
    // ],
    sampleRate: __DEV__ ? 0 : 1,
    tracesSampleRate: __DEV__ ? 0 : 1,
    release: `${Application.nativeApplicationVersion}`,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.mobileReplayIntegration()],
    enableLogs: !__DEV__,
  });

  configureSentryExtras(currentExpoRelease);
};

export async function configureSentryExtras(
  currentExpoRelease: string,
): Promise<void> {
  const { deviceId } = await getDeviceIdentifier();
  Sentry.setExtras({
    deviceId: deviceId,
    expoUpdate: currentExpoRelease,
  });
}

export function configureSentryUser(username: string | null | undefined): void {
  if (username !== null && username !== undefined) {
    Sentry.setUser({ username: username });
  }
}
